import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useMediaQuery } from "@/hooks";
import { useMessagesStore } from "../store/useMessagesStore";
import { ConversationList } from "./ConversationList";
import { ChatPanel } from "./ChatPanel";

export function MessagesWorkspace() {
  const location = useLocation();
  const isDesktop = useMediaQuery("(min-width: 1024px)");
  const [mobileShowChat, setMobileShowChat] = useState(false);
  const activeConversationId = useMessagesStore((s) => s.activeConversationId);
  const setActiveConversationId = useMessagesStore((s) => s.setActiveConversationId);
  const setViewingConversationId = useMessagesStore((s) => s.setViewingConversationId);

  // Contacts (and others) can pass conversationId via navigate state — honor it.
  useEffect(() => {
    const fromState = (location.state as { conversationId?: string } | null)?.conversationId;
    if (fromState && fromState !== activeConversationId) {
      setActiveConversationId(fromState);
    }
  }, [location.state, activeConversationId, setActiveConversationId]);

  // Leaving Messages must clear "viewing" so unread badges work on other pages
  useEffect(() => {
    return () => {
      setViewingConversationId(null);
    };
  }, [setViewingConversationId]);

  // Keep mobile chat open when a conversation is selected (e.g. from contacts)
  useEffect(() => {
    if (!isDesktop && activeConversationId) {
      setMobileShowChat(true);
    }
  }, [activeConversationId, isDesktop]);

  if (isDesktop) {
    return (
      <div className="flex min-h-0 w-full flex-1 overflow-hidden rounded-[6px] border border-border bg-surface shadow-[0_12px_36px_rgba(65,33,10,0.08)] dark:shadow-[0_12px_36px_rgba(0,0,0,0.35)]">
        <ConversationList />
        <div className="relative flex h-full min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
          <ChatPanel key={activeConversationId ?? "welcome"} />
        </div>
      </div>
    );
  }

  return (
    <div className="flex min-h-0 w-full flex-1 overflow-hidden rounded-[6px] border border-border bg-surface shadow-[0_12px_36px_rgba(65,33,10,0.08)] dark:shadow-[0_12px_36px_rgba(0,0,0,0.35)]">
      {mobileShowChat && activeConversationId ? (
        <div className="relative flex h-full min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
          <ChatPanel
            key={activeConversationId}
            showBack
            onBack={() => setMobileShowChat(false)}
          />
        </div>
      ) : (
        <ConversationList onSelectConversation={() => setMobileShowChat(true)} />
      )}
    </div>
  );
}
